import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import {
  FulfillmentGroupData,
  getSelectedRate,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const RateCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> = {
  header: "Rate",
  cell: (row) => {
    if (row.ratesPendingSince) {
      return "";
    }
    const rate = getSelectedRate({
      selectedShippingRate: row.selectedShippingRate,
      availableRates: row.availableShipmentRates?.rates,
    });
    return rate?.rate ? `$${parseFloat(rate.rate).toFixed(2)}` : "";
  },
};
